import React from "react";
import { PageHeader } from "antd";
import { TagsOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import CategoryForm from "./form";

export default function CategoryCreate() {
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Categories", path: "/billing/categories" },
          { label: "Create", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <TagsOutlined /> }}
        title="Add Category"
        style={{ marginBottom: 16 }}
      />
      <CategoryForm />
    </div>
  );
}
